import { render, staticRenderFns } from "./operationsRoles.vue?vue&type=template&id=4978b4c6&scoped=true"
import script from "./operationsRoles.vue?vue&type=script&lang=js"
export * from "./operationsRoles.vue?vue&type=script&lang=js"
import style0 from "./operationsRoles.vue?vue&type=style&index=0&id=4978b4c6&prod&lang=scss&scoped=true"
import style1 from "./operationsRoles.vue?vue&type=style&index=1&id=4978b4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978b4c6",
  null
  
)

export default component.exports